import { jsx as _jsx } from "react/jsx-runtime";
import { Collapsible } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getInfoListWidgetStyles } from '../../InfoListWidgetStyles';
import AccordianHeader from '../accordian-header/AccordianHeader';
function InfoListHeaderElementCard(props) {
  var id = props.id,
    item = props.item,
    index = props.index,
    accordionRef = props.accordionRef,
    setCountOpenTabs = props.setCountOpenTabs,
    children = props.children,
    showAccordian = props.showAccordian,
    showRightPadding = props.showRightPadding,
    onUserAction = props.onUserAction,
    _props$onToggleMetaDa = props.onToggleMetaData,
    onToggleMetaData = _props$onToggleMetaDa === void 0 ? {} : _props$onToggleMetaDa,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InfoListElementCard' : _props$testID;
  var _ref = item || {},
    _ref$initialOpen = _ref.initialOpen,
    initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen;
  var infoListWidgetStyles = getInfoListWidgetStyles();
  if (showAccordian) {
    return _jsx(Collapsible, Object.assign({
      ref: refState => {
        accordionRef.current["innerItem+" + index] = refState;
      },
      style: infoListWidgetStyles.infoListCollapsibleStyle,
      testID: testID,
      titleNoVerticalPadding: true,
      titlePaddingToken: "SPACING_16",
      childNoVerticalPadding: true,
      removeOverflow: true,
      childNoHorizontalPadding: true,
      titleComponent: _jsx(View, Object.assign({
        style: {
          flex: 1
        }
      }, {
        children: _jsx(AccordianHeader, {
          noHorizontalSpacing: true,
          onUserAction: onUserAction,
          item: item,
          showAccordian: true
        }, "innerItem+" + index)
      })),
      initialOpen: initialOpen,
      onToggleHandler: event => {
        {
          onToggleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onToggleMetaData), {
            id,
            item,
            index
          }));
        }
        if (event) {
          setCountOpenTabs(prev => prev + 1);
        } else {
          setCountOpenTabs(prev => prev != 0 && prev - 1);
        }
      },
      version: "variable-width",
      contentStyle: infoListWidgetStyles.customCardPadding
    }, {
      children: children
    }), "innerItem+" + index);
  } else {
    return _jsx(AccordianHeader, {
      item: item,
      onUserAction: onUserAction,
      showAccordian: false,
      showRightPadding: showRightPadding
    }, "#" + index);
  }
}
export default InfoListHeaderElementCard;